import axios from 'axios'
import {BASE_URL, API_VERSION, PARTICIPANTS} from '../endpoints'

export const GET_ALL_PARTICIPANTS = 'GET_ALL_PARTICIPANTS'
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT'
export const EDIT_PARTICIPANT = 'EDIT_PARTICIPANT'
export const DELETE_PARTICIPANT = 'DELETE_PARTICIPANT'
export const GET_PARTICIPANTS = 'GET_PARTICIPANTS'

export const getAllItems = (query) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    const queryString = new URLSearchParams(query).toString();

    return axios.get(`${BASE_URL}${PARTICIPANTS}?${queryString}`, options)
        .then((response) => {
            dispatch({
                type: GET_ALL_PARTICIPANTS,
                payload: {
                    participants: response.data.data,
                    total: response.data.data.totalElements // Adjust based on API
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};


export const addItem = (payload) => (dispatch) => {
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }
    return axios.post(BASE_URL + PARTICIPANTS, payload, apiHeader)
        .then(response => {
            console.log(response.data)
            // dispatch({ type: ADD_PARTICIPANT, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const deleteItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.delete(BASE_URL + PARTICIPANTS + '/' + id, apiHeader)
        .then(response => {
            // dispatch({ type: DELETE_PARTICIPANT, payload: id });
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const editItem = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.patch(BASE_URL + PARTICIPANTS + '/' + id, payload, apiHeader)
        .then(response => {
            // dispatch({ type: EDIT_PARTICIPANT, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}


export const getItems = (key, query) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    const queryString = new URLSearchParams(query).toString();

    return axios.get(`${BASE_URL}${PARTICIPANTS}?${queryString}`, options)
        .then((response) => {
            dispatch({
                type: GET_PARTICIPANTS,
                payload: {
                    key,
                    participants: response.data.data.participants // Adjust based on API
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};
